import { render } from "./UIInput.vue?vue&type=template&id=265a88c4"
import script from "./UIInput.vue?vue&type=script&lang=js"
export * from "./UIInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__